import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import CTACard from "../../../V2/Cards/CTACard"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokCTACard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.CTACard>) => {
  return (
    <CTACard
      ctaText={blok.ctaText}
      trackingEvent={blok.trackingEvent}
      backgroundColor={blok.backgroundColor}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokCTACard
